import SideMenuBar from "./components/SideMenuBar";
import {Bookmark, Briefcase, MessageSquare, User, Menu as MENU, Users, X} from "react-feather";
import {useEffect, useState} from "react";
import {AiOutlineComment} from "react-icons/ai";
import {LiaStackExchange} from "react-icons/lia";
import {VscCompassActive} from "react-icons/vsc";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";

export default function Dashboard() {
    const [activeDeliveries, setActiveDeliveries] = useState('0')
    const [pastDeliveries, setPastDeliveries] = useState('0')
    const [messages, setMessages] = useState('0')
    const [isMobileShow, setIsMobileShow] = useState(false);
    const [isActiveDeliveriesLoading, setIsActiveDeliveriesLoading] = useState(false)
    const [isPastDeliveriesLoading, setIsPastDeliveriesLoading] = useState(false)
    const [isMessagesLoading, setIsMessagesLoading] = useState(false)

    useEffect(() => {
        LoadActiveDeliveries();
        LoadPastDeliveries();
    }, []);

    const LoadActiveDeliveries = () => {
        try {
            setIsActiveDeliveriesLoading(true)
            var formdata = new FormData();
            formdata.append("page", "GetActiveAppointments");
            formdata.append("role", localStorage.getItem("Role"));
            formdata.append("id", localStorage.getItem("UserId"));

            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            fetch(`${API_LINK}Appointment.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 1) {
                        setActiveDeliveries(result.data[0].count.toString());
                        setIsActiveDeliveriesLoading(false)
                    } else {
                        setActiveDeliveries('0');
                        setIsActiveDeliveriesLoading(false)
                    }
                })
                .catch(error => {
                    console.log('error', error)
                    setIsActiveDeliveriesLoading(false)
                });
        } catch (e) {
            console.log(e);
            setIsActiveDeliveriesLoading(false)
        }
    }
    const LoadPastDeliveries = () => {
        try {
            var formdata = new FormData();
            formdata.append("page", "GetPastAppointments");
            formdata.append("role", localStorage.getItem("Role"));
            formdata.append("id", localStorage.getItem("UserId"));

            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            fetch(`${API_LINK}Appointment.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 1) {
                        setPastDeliveries(result.data[0].count.toString());
                    } else {
                        setPastDeliveries('0');
                    }
                })
                .catch(error => {
                    console.log('error', error)
                });
        } catch (e) {
            console.log(e);
        }
    }

    return (<>
        {/*<MenuHeader page={'dashboard'}/>*/}

        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Welcome Back! {localStorage.getItem("UserName")}</h2>
                    <div className="dashboard-cards-container">
                        <div className="dashboard-card">
                            <div className="icon">
                                <VscCompassActive/>
                            </div>
                            <div className="detail">
                                <h2 className="heading">{activeDeliveries}</h2>
                                <p>Active Appointments</p>
                            </div>
                        </div>
                        <div className="dashboard-card">
                            <div className="icon">
                                <LiaStackExchange/>
                            </div>
                            <div className="detail">
                                <h2 className="heading">{pastDeliveries}</h2>
                                <p>Past Appointments</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
